import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';

const COMMENT_REACTIONS_FRAGMENT = gql(`
  fragment groupReactions_commentReactions on CommentReaction {
    id
    emoji
    author {
      id
    }
  }
`);

const THREAD_REACTIONS_FRAGMENT = gql(`
  fragment groupReactions_threadReactions on ReactionFields {
    id
    emoji
    author {
      id
    }
  }
`);

type GroupReactionsReactionFragment =
  | DocumentType<typeof COMMENT_REACTIONS_FRAGMENT>
  | DocumentType<typeof THREAD_REACTIONS_FRAGMENT>;

type Item<T extends GroupReactionsReactionFragment> = {
  emoji: string;
  items: T[];
  isActive: boolean;
};

// Group reactions by emoji char, ordered by first occurrence.
const groupReactions = <T extends GroupReactionsReactionFragment>(
  reactions: T[],
  currentUserId: string,
) => {
  const emojiReactions: Record<string, Item<T>> = {};
  const groupedReactions: Item<T>[] = [];
  reactions.forEach((reaction) => {
    const { emoji, author } = reaction;
    let currentReaction = emojiReactions[emoji];
    if (!currentReaction) {
      currentReaction = { emoji, items: [], isActive: false };
      groupedReactions.push(currentReaction);
      emojiReactions[emoji] = currentReaction;
    }
    currentReaction.items.push(reaction);
    if (author.id === currentUserId) {
      currentReaction.isActive = true;
    }
  });
  return groupedReactions;
};

export default groupReactions;
